(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/create-game/assets/javascripts/advanced-options.js') >= 0) return;  svs.modules.push('/components/marketplace/create-game/assets/javascripts/advanced-options.js');
'use strict';

const _React = React,
  useContext = _React.useContext;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector,
  useDispatch = _ReactRedux.useDispatch;
const url = svs.utils.url;
const resolveProductId = svs.utils.products.resolveProductId;
const Input = svs.ui.reactForm.Inputv2;
const createBetProposal = svs.components.marketplaceData.createBetProposal;
const _svs$components$marke = svs.components.marketplaceData.selectors.draws,
  getDraw = _svs$components$marke.getDraw,
  getDrawEvents = _svs$components$marke.getDrawEvents,
  selectDrawEventsErrorMessage = _svs$components$marke.selectDrawEventsErrorMessage;
const selectCreateBetProposal = svs.components.marketplaceData.selectors.betProposal.selectCreateBetProposal;
const selectCreateGame = svs.components.marketplaceData.selectors.createGame.selectCreateGame;
const BetProposalCreate = svs.components.marketplace.betProposal.BetProposalCreate;
const getRowId = svs.components.marketplace.helpers.getRowId;
const excludedProducts = svs.components.marketplace.betProposal.excludedProducts;
const EventListContainer = svs.components.marketplace.eventList.EventListContainer;
const MarketplaceBrandContext = svs.components.marketplace.marketplaceBrand.MarketplaceBrandContext;
const changeDescription = svs.components.marketplaceData.createGame.actions.changeDescription;
const AdvancedOptions = _ref => {
  let groupId = _ref.groupId,
    activatedDrawId = _ref.activatedDrawId,
    isEditMode = _ref.isEditMode;
  const dispatch = useDispatch();
  const _useContext = useContext(MarketplaceBrandContext),
    getBrandedDisplayName = _useContext.getBrandedDisplayName;
  const drawEventsErrorMessage = useSelector(selectDrawEventsErrorMessage);
  const _useSelector = useSelector(selectCreateGame),
    drawNumber = _useSelector.selectedDraw,
    productName = _useSelector.selectedProduct;
  const _useSelector2 = useSelector(state => state.CreateGame),
    description = _useSelector2.description;
  const betProposalRowId = activatedDrawId || getRowId(productName, drawNumber, groupId);
  const _useSelector3 = useSelector(state => getDraw(state, {
      drawNumber,
      productName
    })),
    raceId = _useSelector3.raceId;
  const drawEvents = useSelector(state => getDrawEvents(state, {
    drawNumber,
    productName
  }));
  const betProposal = useSelector(state => selectCreateBetProposal(state, {
    activatedDrawId: betProposalRowId
  })) || {};
  let betProposalElement;
  if (drawEventsErrorMessage) {
    betProposalElement = React.createElement("span", {
      className: "f-bold block margin-bottom-half",
      "data-testid": "bet-proposal-error"
    }, drawEventsErrorMessage);
  } else if (productName && excludedProducts[url.encode(productName.toLowerCase())]) {
    betProposalElement = React.createElement(EventListContainer, {
      activatedDrawId: activatedDrawId,
      drawNumber: drawNumber,
      events: drawEvents || [],
      groupId: groupId,
      productName: productName,
      warningMessage: "Det g\xE5r inte att g\xF6ra n\xE5gon radskiss till ".concat(getBrandedDisplayName(resolveProductId(productName)), ".")
    });
  } else {
    betProposalElement = React.createElement("div", {
      className: "margin-top-2 margin-bottom-2"
    }, React.createElement(BetProposalCreate, {
      drawNumber: drawNumber,
      events: drawEvents || [],
      isDisabled: false,
      isLoading: isNaN(raceId) && !drawEvents || isNaN(raceId) && (drawEvents === null || drawEvents === void 0 ? void 0 : drawEvents.length) <= 0,
      onClearRow: () => {
        dispatch(createBetProposal.actions.clearRow(activatedDrawId, productName, drawNumber, groupId));
      },
      productName: productName,
      raceId: raceId,
      selectedOutcomes: betProposal,
      toggleOutcome: event => {
        dispatch(createBetProposal.actions.toggleOutcome(activatedDrawId, event, productName, drawNumber, groupId, event.participantNumber));
      }
    }));
  }
  return React.createElement("div", {
    "data-testid": "qa-advanced-options"
  }, betProposalElement, React.createElement("div", {
    className: "control-group input-v2-bg-white margin-bottom-2"
  }, React.createElement(Input, {
    className: "description-input qa-description",
    id: "create-game-input-description",
    label: "Meddelande",
    maxLength: 900,
    multiline: true,
    onChange: _ref2 => {
      let target = _ref2.target;
      return dispatch(changeDescription(target.value));
    },
    placeholder: "Kort beskrivning av spelet",
    value: description
  })));
};
setGlobal('svs.components.marketplace.createGame.AdvancedOptions', AdvancedOptions);

 })(window);